import { httpClient } from '@/config/httpClient';

export async function getUserLanguage(userId: string) {
  return httpClient.get(`/user/language/${userId}`);
}
